<template>
  <CCard>
    <CCardBody>
      <h5 class="text-primary">Country Specific Count</h5>
      <div class="w-100 d-flex justify-content-center align-items-center">
        <!-- <GeoChartClinical
          v-if="candidatesData.length > 0"
          :candidates="candidatesData"
        /> -->
        <iframe
          src="/map/clinicalMap.html"
          width="1366"
          height="550"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </CCardBody>
  </CCard>
</template>
<script>
import GeoChartClinical from "./GeoChartClinical.vue";
export default {
  name: "CountrySpecificCount",
  components: {
    GeoChartClinical,
  },
  computed: {
    candidatesData() {
      const res = [
        { country: "canada", count: 139 },
        { country: "germany", count: 130 },
        { country: "sweden", count: 130 },
        { country: "new zealand", count: 125 },
        { country: "australia", count: 104 },
        { country: "london", count: 128 },
        { country: "united states", count: 116 },
        { country: "ireland", count: 128 },
      ];
      return res;
    },
  },
};
</script>

<style scoped>
h4 {
  text-align: center;
}
</style>
